import tippy from 'tippy.js';
import { hideAll } from 'tippy.js';
import Vue from 'vue';
import { createApp } from 'vue'
import { createVfm } from 'vue-final-modal';
import { ModalsContainer, useModal } from 'vue-final-modal'
import 'vue-final-modal/style.css';
import ModalContentComponent from '../passes-comparison-table-block/ModalContentComponent.vue';

const pageHasComparisonTable = document.querySelector(".passes-comparison-table-block table thead") != null;

if (pageHasComparisonTable) {

    const initialPadding = "50%"; //Just set it to 50% since images are 600x300pixels which equals to 50% padding

    function throttle(fn, wait) {
        var time = Date.now();
        return function () {
            if (time + wait - Date.now() < 0) {
                fn();
                time = Date.now();
            }
        };
    }

    function checkIfImgShouldCollapse(distanceToTop, distanceToBottom) {

        if (window.matchMedia("(max-height: 1200px)").matches) {

            if (distanceToTop <= distanceToBottom) {
                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__img-and-text__image").forEach((image) => {
                    image.style.paddingBottom = "0px";
                });
            } else if (distanceToTop > distanceToBottom) {
                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__img-and-text__image").forEach((image) => {
                    image.style.paddingBottom = initialPadding;
                });
            }

        }

    }

    function checkIfLegalTextShouldCollapse(distanceToTop, distanceToBottom) {

        if (window.matchMedia("(max-height: 1200px)").matches) {

            if (distanceToTop <= distanceToBottom) {

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__legal-text").forEach((legalText) => {
                    legalText.style.display = "none";
                });

            } else if (distanceToTop > distanceToBottom) {

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__legal-text").forEach((legalText) => {
                    legalText.style.display = "flex";
                });

            }
        }

    }

    function checkIfOtherItemsShouldCollapse(distanceToTop, distanceToBottom) {

        if (window.matchMedia("(max-height: 1200px)").matches) {

            if (distanceToTop <= distanceToBottom) {

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__img-and-text__small-teaser").forEach((teaser) => {
                    teaser.style.display = "none";
                });

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__price-area").forEach((priceArea) => {
                    priceArea.style.display = "none";
                });

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__additional-button-area").forEach((buttonArea) => {
                    buttonArea.style.display = "none";
                });

            } else if (distanceToTop > distanceToBottom) {

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__img-and-text__small-teaser").forEach((teaser) => {
                    teaser.style.display = "flex";
                });

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__price-area").forEach((priceArea) => {
                    priceArea.style.display = "flex";
                });

                document.querySelectorAll(".passes-comparison-table-block table .comparable-item__additional-button-area").forEach((buttonArea) => {
                    buttonArea.style.display = "block";
                });
            }

        }

    }

    function checkForItems() {
        var tableHead = document.querySelector(".passes-comparison-table-block table thead");
        var distanceToTop = tableHead.getBoundingClientRect().top;
        //console.log("distanceToTop: ", distanceToTop);

        var pageHeader = document.querySelector("header");
        var distanceToBottom = pageHeader.getBoundingClientRect().bottom;
        //console.log("distanceToBottom: ", distanceToBottom);

        checkIfImgShouldCollapse(distanceToTop, distanceToBottom);
        checkIfLegalTextShouldCollapse(distanceToTop, distanceToBottom);
        checkIfOtherItemsShouldCollapse(distanceToTop, distanceToBottom);
    }

    /* Feature detection */
    let passiveIfSupported = false;

    try {
        window.addEventListener("test", null,
            Object.defineProperty(
                {},
                "passive",
                {
                    get: function () { passiveIfSupported = { passive: true }; }
                }
            )
        );
    } catch (err) { }

    window.addEventListener("scroll", throttle(checkForItems, 100), passiveIfSupported);

    document.addEventListener('click', (e) => {
        const card = e.target.closest('.comparable-item');
        if (!card) return;
        if (e.target.closest('a, button')) return;
        const ctaButton = card.querySelector('.comparable-item__button-area a, .comparable-item__button-area button');
        if (ctaButton) setTimeout(() => ctaButton.click(), 0);
    });

    let modal;

    const passesComparisonTable = createApp({
        created(){
            this.$root.$on('confirm', this.closeModal)
        },
        methods: {
            showModal(e) {
                const closeModalText = e.target.dataset.closeModalText;
                const passes = e.target.dataset.ids;
                const selectedPass = e.target.dataset.selectedId;
                const useInvertedDates = e.target.dataset.useInvertedDates === "true" ? true : false;

                modal = useModal({
                    component: ModalContentComponent,
                    attrs: {
                        clickToClose: true,
                        escToClose: true,
                        passes: passes,
                        selectedPass: selectedPass,
                        useInvertedDates: useInvertedDates,
                        closeModalText: closeModalText,
                    }
                });

                modal.open();
            },
            closeModal() {
                modal.destroy();
            }
        },
    });
    
    passesComparisonTable.component('modals-container', ModalsContainer).component('modal-content-component', ModalContentComponent);
    const vfm = createVfm();
    passesComparisonTable.use(vfm).mount('#pctb');

    tippy(document.querySelectorAll('[rel="tooltip"]'), {
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        allowHTML: true,
        hideOnClick: false
    });

    window.addEventListener("scroll", hideAll({ duration: 0 }), passiveIfSupported);
}